import React, { useRef } from 'react';
import ResourceCenterTableRow from './ResourceCenterTableRow';
import TableSkeleton from '../../BaseComponents/TableSkeleton';
import { Resource } from '../../../api/resourceCenter';
import './ResourceCenterTable.scss';
import downArrow from '../../../assets/icons/downArrow.png';

interface ResourceCenterTableProps {
  resourcesList: Resource[];
  isLoading: boolean;
  sortingLoading: boolean;
  onViewResource: (resource: Resource) => void;
  onEditResource: (resource: Resource) => void;
  onDeleteResource: (resourceId: number) => void;
  onSort: (field: string) => void;
}

const ResourceCenterTable: React.FC<ResourceCenterTableProps> = ({ 
  resourcesList, 
  isLoading, 
  sortingLoading,
  onViewResource,
  onEditResource, 
  onDeleteResource,
  onSort
}) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const tableHeader = (
    <div className='table-header'>
      <div className='header-cell'>Name <img src={downArrow} alt="" style={{ cursor: 'pointer' }} onClick={() => onSort('name')} /></div>
      <div className='header-cell'>Blood Biomarkers <img src={downArrow} alt="" style={{ cursor: 'pointer' }} onClick={() => onSort('biomarkers')} /></div>
      <div className='header-cell'>Conditions</div>
      <div className='header-cell'>MRI Conditions</div>
      <div className='header-cell'>Body Systems</div>
      <div className='header-cell'></div>
    </div>
  );

  if (isLoading) {
    return (
      <div className='resource-center-container'>
        <div className='resource-center-table'>
          {tableHeader}
          <div className='table-body' ref={scrollContainerRef}>
            <div className='loading-state'>
              <div className='loading-spinner'></div>
              <div className='loading-text'>Loading content...</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='resource-center-container'>
      <div className='resource-center-table'>
        {tableHeader}
        <div className='table-body' ref={scrollContainerRef}>
          {sortingLoading ? (
            <TableSkeleton rows={5} columns={6} />
          ) : resourcesList?.length > 0 ? (
            resourcesList.map((resource) => (
              <ResourceCenterTableRow
                resourceData={resource}
                key={resource.id}
                onViewResource={onViewResource}
                onEditResource={onEditResource}
                onDeleteResource={onDeleteResource}
              />
            ))
          ) : (
            <div className='empty-state'>
              <div className='empty-text'>No content found</div>
              <div className='empty-subtext'>Click "Add Content" to create your first content item.</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResourceCenterTable;
